export const WorkshopTypes = [
  { _id: 'career', name: 'Career planning' },
  { _id: 'cohort', name: 'Cohort-based CEIS series' },
  { _id: 'employability', name: 'Employability skills' },
  { _id: 'job', name: 'Job search skills' },
  { _id: 'personal', name: 'Personal skills' },
  { _id: 'other', name: 'Other' },
];
